import { createContext } from "react";

const initialValue = {
  provinces: [],
  user: {
    name: "",
    role: "",
    email: "",
    auth_token: "",
  },
};

export const ministry_Context = createContext(initialValue);

ministry_Context.displayName = "Ministry Context";
